/** Period keys on `MaritimeForecast.periods` and `MaritimeForecastAreasInner.periods`. */
export const MARITIME_FORECAST_PERIOD_KEYS = {
  hours0_12: "hours_0_12",
  hours12_24: "hours_12_24",
  day1: "day_1",
  day2: "day_2",
} as const;

export const MARITIME_FORECAST_SHORT_RANGE_PERIOD_KEYS = [
  MARITIME_FORECAST_PERIOD_KEYS.hours0_12,
  MARITIME_FORECAST_PERIOD_KEYS.hours12_24,
] as const;

export type MaritimeForecastShortRangePeriodKey =
  (typeof MARITIME_FORECAST_SHORT_RANGE_PERIOD_KEYS)[number];
